<!-- 列表单元格 -->
<template>
  <div class="teas-card-desc mobile">
    <!-- <img v-if="isShowBg" :src="require('../../assets/styles/themes/img/img-bg.png')" class="bg-img" alt=""> -->
    <div v-if="isShowBg" class="bg-img"></div>
    <div
      :class="[
        'teas-card-desc-card',
        'teas-card-desc-' + shape,
        border ? 'dsf-teas-border-bottom' : '',
      ]"
    >
      <div :class="['teas-card-desc-bd-title', 'teas-card-desc-hd']">
        <slot name="titleLeft"> </slot>
        <div :class="['title',titleClass]">{{ title }}</div>
        <slot name="titleRight"> </slot>
      </div>
      <!-- <div :class="['teas-card-desc-hd', titleClass]">
        {{ title }}
      </div> -->
      <div class="teas-card-desc-bd">
        <div class="teas-card-desc-bd-left">
          <van-row :gutter="gutter">
            <slot />
          </van-row>
        </div>
        <div class="teas-card-desc-bd-right">
          <!-- 比如放印章 -->
          <slot name="bdright"></slot>
        </div>
      </div>
      <div class="teas-card-desc-ft">
        <slot name="ft"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
// 数据格式案例
const testData = {
  title:
    "这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题",
};

export default dsf.component({
  name: "DsfMobileTeasCardDesc",
  ctrlCaption: "描述卡片",
  mixins: [$mixins.control],
  design: {},
  props: {
    // 标题
    title: {
      type: String,
      default: "",
    },
    // 标题几行显示
    titleEllipsis: {
      type: Number,
      default: 2,
    },
    // 卡片的圆角
    // square-半圆角5px  none-无圆角
    shape: {
      type: String,
      default: "square",
    },
    // 栅格化间距 单位px
    gutter: {
      type: Number,
      default: 0,
    },
    // 是否显示背景图
    isShowBg: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    titleClass() {
      switch (this.titleEllipsis) {
        case 1:
          return "van-ellipsis";
        case 2:
          return "van-multi-ellipsis--l2";
        default:
          return "van-ellipsis";
      }
    },
  },
  created() {},
  mounted() {},
  methods: {},
});
</script>
